
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RegularUserVideo"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"folder_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"download_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"complete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archived"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"video_properties"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_is_png"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"processing_information"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trim_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trim_ranges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatars"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumb"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultPlay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ogFull"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullPlay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultGif"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultGifPlay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"animatedPreview"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultThumbnails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"static"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"signedThumbnails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultPlay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ogFull"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullPlay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultGif"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultGifPlay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"animatedPreview"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"signedDefaultThumbnails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"static"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"use_gif"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"received_a_view"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"current_user_is_owner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_protected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"needs_password"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"do_not_show_comments"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":849}};
    doc.loc.source = {"body":"fragment VideoFragment on RegularUserVideo {\n  id\n  active_status\n  owner_id\n  folder_id\n  name\n  download_enabled\n  complete\n  archived\n  video_properties {\n    thumbnail_is_png\n    duration\n  }\n  processing_information {\n    trim_id\n    trim_ranges {\n      from\n    }\n  }\n  owner {\n    first_name\n    last_name\n    avatars {\n      thumb\n    }\n  }\n  thumbnails {\n    default\n    defaultPlay\n    ogFull\n    full\n    fullPlay\n    defaultGif\n    defaultGifPlay\n    animatedPreview\n  }\n  defaultThumbnails {\n    default\n    static\n  }\n  signedThumbnails {\n    default\n    defaultPlay\n    ogFull\n    full\n    fullPlay\n    defaultGif\n    defaultGifPlay\n    animatedPreview\n  }\n  signedDefaultThumbnails {\n    default\n    static\n  }\n  use_gif\n  received_a_view\n  createdAt\n\n  current_user_is_owner\n  is_protected\n  needs_password\n  do_not_show_comments\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["VideoFragment"] = oneQuery(doc, "VideoFragment");
        
